import ContactSection from "../sectionHomPage/ContactSection";


const ContactPage = () => {
    return (
        <main>
           <ContactSection/>

        </main>
    );
};

export default ContactPage;
